<header role="banner"
	class="header-container">
	<section class="brand-section"
		aria-label="Main navigation">
		<button class="brand-division" (click)="navigateToLogin()" type="button" [attr.aria-label]="'Navigate to ' + brandText">
			{{ brandText }}
		</button>
	</section>
		<nav class="main-navigation"
		aria-label="Primary navigation">
		<div class="nav-separator" *ngIf="!isVendorManagementRoute">
			<div class="nav-separator">
				<span class="separator-line" aria-hidden="true"></span>
			  </div>
		</div>
		<div  *ngIf="!isVendorManagementRoute">
			<div class="nav-menu" *ngFor="let route of navigations">
				<a [routerLink]="route.path" *ngIf="currentUrl?.startsWith(route.path)"
					class="nav-link"
					routerLinkActive="active"
					role="menuitem"
					tabindex="0">
					{{ route.title || '' }}
				</a>
			</div>
		</div>
		<div class="nav-spacer"></div>
	</nav>


	<section class="notification-container">
		<div class="notification-icon-wrapper" *ngIf="shouldShowNotifications">
			<emerald-icon
				[icon]="headerConstants.help.notificationIconName"
				[ariaLabel]="headerConstants.help.notificattionTitle"
				[color]="'rgba(255, 255, 255, 0.6)'"
				[fontsizeInRem]="1.5"
				class="notification-icon"
				(click)="notificationPanel.toggle($event)"
			></emerald-icon>
			<span class="notification-badge" *ngIf="unreadCount > 0 && notifications.length > 0">
			</span>
		</div>

		<p-overlayPanel #notificationPanel>
			<div class="overlay-panel" >
				<div class="profile-card">
					<div class="notification-support-panel">
						<div class="notification-support-header">
							<span>Notifications</span>
							<emerald-icon
								[icon]="headerConstants.help.closeIconName"
								(click)="notificationPanel.hide()">
							</emerald-icon>
						</div>

						<div class="notification-support-content-wrapper" *ngIf="notifications.length > 0">
							<div class="notification-support-item" *ngFor="let notification of notifications">
								<div class="notification-support-content">
									<div class="notification-support-message">
										<strong>Please update the quarterly rating for {{ notification.name }} (PSID {{ notification.id }}).</strong>
									</div>
									<emerald-button 
										[size]="'Small'"
										[type]="'Light'"
										Color="primary"
										(click)="handleNotificationAction(notification.id)"
										label="">
										Add Rating
									</emerald-button>
								</div>
							</div>
						</div>

						<div *ngIf="notifications.length === 0" class="no-notification-support-items">
							No new notifications
						</div>
					</div>
				</div>
			</div>
		</p-overlayPanel>

		<emerald-icon
			[icon]="headerConstants.help.iconName"
			[ariaLabel]="headerConstants.help.title"
			title="{{headerConstants.help.title}}"
			[color]="'rgba(255, 255, 255, 0.6)'"
			[fontsizeInRem]="1.5"
			(click)="toggleHelp()"
			class="help-icon"
		></emerald-icon>

		<div class="help-support-panel"
			[class.active]="isHelpPanelOpen">
			<div class="help-support-header">
				<span>{{ headerConstants.help.title }}</span>
				<emerald-icon
					[icon]="headerConstants.help.closeIconName"
					(click)="closeHelp()">
				</emerald-icon>
			</div>

			<div class="help-support-item" *ngFor="let helpItem of helpItems">
				<div class="help-support-content">
					<div class="help-support-message">
						{{ headerConstants.help.supportMessage }}
						<a [href]="'mailto:' + helpItem.contact" class="help-support-link">{{ headerConstants.help.supportEmailLabel }}</a>
					</div>
					<emerald-button
						[size]="'Small'"
						[type]="'Light'"
						Color="primary"
						(click)="handleHelpAction(helpItem)"
						label=""
						*ngIf="helpItem.action">
						{{ helpItem.action }}
					</emerald-button>
				</div>
			</div>

			<div *ngIf="helpItems?.length === 0" class="no-help-support-items">
				{{ headerConstants.help.noHelpMessage }}
			</div>
		</div>
	</section>
	  <section class="user-section">
		<div className="avatar">
		  <emerald-avatar
		  	title="{{authService.userGivenName}}"
			[initials]="authService.userInitials"
			[size]="'medium'"
			(click)="openMenu = !openMenu; op.toggle($event)"
		  >
		  </emerald-avatar>
	 	</div>
	  <p-overlayPanel #op >
        <div class="overlay-panel">
            <div class="profile-card">				
				<div class="profile-details">
					<div class="detail-item">
						<div class="profile-avatar-large">
							<span class="avatar-initials">{{authService.userInitials}}</span>
						</div>
						<div class="detail-content">
							
							<span class="detail-value">{{authService.oktaUserProfile?.name ?? "Not available"}}</span>
						</div>
					</div>
					
					<div class="detail-item">
						<div class="detail-icon">
							<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
								<path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
							</svg>
						</div>
						<div class="detail-content">
							<div class="email-container">
								<button class="detail-value email-link" 
										type="button"
										(click)="copyToClipboard(authService.oktaUserProfile?.email)"
										[attr.aria-label]="'Copy email: ' + (authService.oktaUserProfile?.email ?? 'Not available')">
									{{authService.oktaUserProfile?.email ?? "Not available"}}
								</button>
								<button class="copy-icon-button" 
										type="button"
										(click)="copyToClipboard(authService.oktaUserProfile?.email)"
										[attr.aria-label]="'Copy email to clipboard'"
										title="Copy email">
									<svg class="copy-icon" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
										<path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
									</svg>
								</button>
							</div>
						</div>
					</div>
					
					<div class="detail-item">
						<div class="detail-icon">
							<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
								<path d="M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 0 0-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"/>
							</svg>
						</div>
						<div class="detail-content">
							<span class="detail-value">{{jobTitle || "Not specified"}}</span>
						</div>
					</div>
				</div>
			</div>
			<button class="overlay-list-item" 
					type="button"
					(click)="authService.signOut()">
				<svg class="logout-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
					<path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.59L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
				</svg>
				<span class="overlay-list-item-text">
					Logout
				</span>
			</button>
        </div>
    </p-overlayPanel>
	</section>
</header>
